'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.cos;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/cos.js
// module id = 657
// module chunks = 0